import TemplateView from '../../../TemplateView'
import InputField from '../../../components/InputField'
import {isInt} from '../../../atUtils'

export default class SettingsNumberInput extends TemplateView {
    constructor({
        additionalClass,
        title,
        value,
        units,
        maxLength,
        visible = true,
        disabled,
        invalidValueMessage = null,
        onChange = (value) => {},
    }) {
        super()

        this.params = {
            additionalClass,
            title,
            units,
            maxLength,
            disabled,
            onChange,
        }

        this.state = {
            value,
            invalidValueMessage,
            visible,
        }

        this.onStatePropertyChanged('visible', visible => this.$el.toggleClass('visible', visible))

        this.onStatePropertyChanged('value', value => this.valueInput.setState({value}))

        this.onStatePropertyChanged('invalidValueMessage', message => {
            this.valueInput.setState({errorMessage: message})
            this.$valueInputContainer.toggleClass('invalid', !message)
        })

        this.onStatePropertyChanged('disabled', disabled => this.valueInput.setState({disabled: disabled}))
    }

    templateHtml() {
        return `
<div class='settingsNumberInput visible <%=additionalClass%>'>
    <div class='title'><%=title%></div>
    <div class='valueInputContainer'/>
    <div class='units'><%=units%></div>
</div>
`
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            title: this.params.title,
            units: this.params.units,
        }
    }

    afterRender() {
        this.$valueInputContainer = this.find('.valueInputContainer')

        this.valueInput = new InputField({
            onChange: (value) => {
                if (value === '' || isInt(value)) {
                    this.valueInput.setState({value: value === '' ? value : parseInt(value)})
                    this.params.onChange(value === '' ? value : parseInt(value))
                } else {
                    this.valueInput.setState({value: this.state.value})
                }
            },
            additionalClass: 'valueInput',
            maxLength: this.params.maxLength,
        }).init(this.$valueInputContainer)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/components/SettingsNumberInput.js